import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for routing
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Sidebar.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import FontAwesome

const Sidebar = ({ user, setUser }) => {
    // Function to handle user logout
    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                setUser(null); // Clear user state on successful logout
            })
            .catch((error) => {
                console.error('Error logging out: ', error); // Log any errors
            });
    };

    // Check if the user is an admin
    const isAdmin = user && user.role === 'admin';

    return (
        // Sidebar container
        <div className='sideNav'>
            <div>
                {/* Display user's full name and role if available */}
                {user && user.username && <h4>{user.username} ({user.role})</h4>}
                {/* Logout button */}
                <button onClick={handleLogout} className="logout-button">Logout</button>
            </div>

            {/* Conditionally render content based on user's admin status */}
            {isAdmin ? (
                <>
                    {/* Admin-specific navigation links with icons */}
                    <ul>
                        <li><Link to="/all-users" className='link'><i className="fas fa-users"></i> All Users</Link></li>
                        <li><Link to="/admin-users" className='link'><i className="fas fa-user-shield"></i> Admin Users</Link></li>
                        <li><Link to="/regular-users" className='link'><i className="fas fa-user"></i> Regular Users</Link></li>
                        <li><Link to="/activated-users" className='link'><i className="fas fa-user-check"></i> Activated Users</Link></li>
                        <li><Link to="/deactivated-users" className='link'><i className="fas fa-user-times"></i> Deactivated Users</Link></li>
                        <li><Link to="/add-transaction" className='link'><i className="fas fa-exchange-alt"></i> Add Transaction</Link></li>
                    </ul>
                </>
            ) : (
                <>
                    {/* Message for non-admin users */}
                    <h2>Access Denied!</h2>
                </>
            )}
        </div>
    );
};

export default Sidebar;
